import { saveAs } from "file-saver";
import i18n from "../shared/i18n";
import filtr from "./lib/filtr";
import { openFile } from "./file-picker";
import { state } from "./state";
import { $, loadImage } from "../shared/utils";
import * as storage from "../shared/temp-storage";
import config from "../shared/config";

window.log = Function.prototype;
window.logTime = Function.prototype;
window.logTimeEnd = Function.prototype;

const canvas = document.createElement("canvas");

filtr.setStorage(storage);

export async function openPhoto() {
  const file = await openFile();

  if (file) {
    state.photoName = file.name;
    const url = URL.createObjectURL(file);
    return importPhoto(url);
  }
}

export async function savePhoto() {
  const output = await renderOutput(state.style.content.state);
  const jpeg = await encodeJPEG(output);

  saveAs(jpeg, state.photoName);
}

export function importPhoto(url) {
  return filtr.import(url);
}

async function drawWatermark() {
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  const image = await loadImage(`${config.staticRoot}/logo.png`);

  const author = state.style.author && state.style.author.username;

  canvas.width = image.width * 2 + 16;
  canvas.height = image.height;

  ctx.drawImage(image, 0, 0);

  if (author) {
    const textHeight = image.height / 4;

    ctx.fillStyle = "#ffffff";
    ctx.strokeStyle = "#000000";
    ctx.font = `600 ${textHeight}px sans-serif`;
    ctx.textBaseline = "middle";

    const byLineText = i18n.style_made_by;
    const authorText = `@${author}`;
    const textOffsetX = image.width + 48;
    const textOffsetY = image.height / 3;

    ctx.shadowColor = "black";
    ctx.shadowOffsetX = 0;
    ctx.shadowOffsetY = 0;
    ctx.shadowBlur = 2;

    ctx.fillText(byLineText, textOffsetX, textOffsetY);
    ctx.fillText(authorText, textOffsetX, textOffsetY * 2);

    ctx.fillRect(image.width + 24, 16, 3, image.height - 32);
  }

  return canvas;
}

export async function loadWatermark() {
  const watermark = await drawWatermark();

  filtr.setWatermark({
    enabled: true,
    image: watermark,
    position: [-0.9, 0.95],
    scale: 0.5,
  });
}

export async function renderBeforeAfter() {
  const { clientWidth, clientHeight } = $("#preview");
  const width = clientWidth * devicePixelRatio;
  const height = clientHeight * devicePixelRatio;

  const before = await renderImage({}, width, height);
  const after = await renderImage(state.style.content.state, width, height);

  return [before, after];
}

export async function renderImage(state, width, height) {
  const output = await renderOutput(state, width, height);
  return await encodeJPEG(output);
}

export function renderOutput(state, width, height) {
  return filtr.export("data", {
    height,
    renderDependencies: true,
    resize: "fill",
    settings: state,
    watermark: true,
    width,
  });
}

/**
 * Encode JPEG using canvas
 * @param output
 * @returns {Promise<Blob>}
 */
export function encodeJPEG(output) {
  const ctx = canvas.getContext("2d");

  if (!ctx) return;

  canvas.width = output.width;
  canvas.height = output.height;

  const buffer = new Uint8ClampedArray(output.data);
  const imageData = new ImageData(buffer, output.width, output.height);
  ctx.putImageData(imageData, 0, 0);

  return canvasToBlob(canvas);
}

function canvasToBlob(canvas, type = "image/jpeg", quality = 100) {
  return new Promise((resolve) => {
    if (HTMLCanvasElement.prototype["toBlob"]) {
      canvas.toBlob(resolve, type, quality);
    } else if (Object.prototype.hasOwnProperty.call(canvas, "msToBlob")) {
      // IE/Edge only supports png
      type = "image/png";
      resolve(canvas.msToBlob());
    } else {
      const url = canvas.toDataURL(type, quality);
      const blob = dataURLtoBlob(url, { type: type || "image/png" });
      resolve(blob);
    }
  });
}

function dataURLtoBlob(dataURL, options) {
  const byteString = atob(dataURL.split(",")[1]);
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ab], options);
}
